import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { useLocation, useNavigate } from "react-router-dom";
import { AddButton } from "../../utils/commonComponent/Custom/Button";
import { submitSiteDelete } from "./../../utils/commonComponent/delete";
import {
  fetchByTable,
  fetchQuery,
} from "./../../utils/commonComponent/fetched";
import ListSearchSection from "../../utils/commonComponent/Custom/ListSearchSection";
import ListView from "../../utils/commonComponent/Custom/listView";
import { DisciplineOptions } from "../disciplineMaster/disiplineConst";
import { getPermissions } from "../rbac/hasAccess";

const headers = [
  "id",
  "disciplineName",
  "groupName",
  "equipmentName",
  "equipmentId",
  "serialNo",
  "calDate",
  "dueDate",
];

const fields = [
  { value: "equipmentName", label: "Equipment Name" },
  { value: "equipmentId", label: "Equipment Id" },
  { value: "serialNo", label: "Serial Number" },
  { value: "disciplineName", label: "Discipline Name" },
];

const EquipmentsMasterList = (props) => {
  const navigate = useNavigate();
  const location = useLocation();  
  const permissions = getPermissions(props.moduleId);
  const handleEdit = (row) => navigate(`/master/editMasterEquipment/${row.id}`);
  const handleDelete = (row) => submitSiteDelete("equipmentsMaster", row.id);

  const [equipmentsMasterList, setequipmentsMasterList] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [searchBy, setSearchBy] = React.useState(sessionStorage.getItem("searchBy") || "equipmentId");
  const [searchKey, setSearchKey] = React.useState(sessionStorage.getItem("searchKey") || "");
  const [searched, setSearched] = React.useState(sessionStorage.getItem("searched") === "true" || false);
   // Pagination
  const [currentPage, setCurrentPage] = useState(() => Number(sessionStorage.getItem("ListPageCount") || 0));
  const [rowsPerPage, setRowsPerPage] = useState(() => Number(sessionStorage.getItem("ListRowsPerPage") || 30));

  const handlePaginationChange = (page, rows) => {
    setCurrentPage(page);
    setRowsPerPage(rows);
    // fetch new data from backend here
  };

  const getWhereClause = () => {
    const colMap = {
      equipmentName: "equipmentName",
      equipmentId: "equipmentId",
      serialNo: "serialNo",
      disciplineName: "disciplineName",
    };

    const colName = colMap[searchBy];
    const key = searchKey.trim();

    let whereConditions = ["status = 1"];

    if (colName && key) {
      whereConditions.push(`${colName} LIKE '%${key}%'`);
    }

    return whereConditions.length
      ? `WHERE ${whereConditions.join(" AND ")}`
      : "";
  };

  const getDataQuery = () => {
    const whereClause = getWhereClause();

    let paginationSettings = "";
    if (rowsPerPage !== -1) {
      paginationSettings = `LIMIT ${rowsPerPage} OFFSET ${
        rowsPerPage * Number(currentPage)
      }`;
    }

    return `SELECT * FROM equipmentsMaster ${whereClause} ORDER BY id DESC ${paginationSettings};`;
  };

  const getCountQuery = () => {
    const whereClause = getWhereClause();

    return `SELECT COUNT(*) AS totalRows FROM equipmentsMaster ${whereClause};`;
  };

  const fetchData = async () => {
    try {
      const [equData, countResult, groupList] = await Promise.all([
        fetchQuery(getDataQuery()),
        fetchQuery(getCountQuery()),
        fetchQuery("SELECT * FROM discipline"),
      ]);

      const updatedEquData = equData.map((item) => {
        const discipline = DisciplineOptions.find(
          (d) => d.id === item.disciplineId
        );

        return {
          ...item,
          disciplineName: discipline ? discipline.label : null,
          groupName:
            groupList.find((g) => g.id == item.groupId)?.groupName || "",
        };
      });

      setequipmentsMasterList(updatedEquData);
      setTotalRows(countResult?.[0]?.totalRows || 0); // 👈 pagination count
    } catch (error) {
      console.error("Error fetching equipment data:", error);
    }
  };

  const handleSearch = () => {
    if (!searchBy || !searchKey.trim()) {
      alert("Please select a search field and enter a search value.");
      return;
    }
    fetchData();
    setSearched(true);
    // Save search state to sessionStorage
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", location.pathname);
    sessionStorage.setItem("ListPageCount", 0);
    setCurrentPage(0);
  };

  const clearSearch = () => {
    setSearched(false);
    setSearchBy("equipmentId");
    setSearchKey("");
    // Clear all employee list session storage
    sessionStorage.removeItem("ListPageCount");
    sessionStorage.removeItem("ListRowsPerPage");
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched");
    setCurrentPage(0);
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, rowsPerPage]);

  useEffect(() => {
    if (searched == false) {
      fetchData();
    }
  }, [searched]);

  return (
    <>
      {(permissions.create || permissions.allAccess) && (
        <AddButton
          id="btn-add-outline"
          to="/master/editMasterEquipment/0"
          label="Add Equipment"
          icon={<AddIcon fontSize="small" />}
        />
      )}
      <ListSearchSection
        title="Search Equipment"
        fields={fields}
        onSearch={handleSearch}
        dateFilterShow={true}
        searchKey={searchKey}
        setSearchKey={setSearchKey}
        searchBy={searchBy}
        setSearchBy={setSearchBy}
        clearSearch={clearSearch}
        searched={searched}
        setSearched={setSearched}
      />

      <ListView
        headers={headers}
        data={equipmentsMasterList}
        actions={{
          edit: handleEdit,
          delete: handleDelete,
        }}
        showCheckbox={true}
        deleteTableName={"equipmentsMaster"}
        moduleId={props.moduleId}
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        totalRows={totalRows}
        onPaginationChange={handlePaginationChange}
      />
    </>
  );
};

export default EquipmentsMasterList;
